import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

import { desktopVw } from '../../styles/utils'
import Collapsible from '../Account/Collapsible'

const StyledReferralPoints = styled.div`
  padding: 20px 0;
`

const Overview = styled.div`
  display: block;
  margin-top: 12px;

  @media (min-width: ${props => props.theme.breakpoints.desktopSmall}px) {
    margin-bottom: ${desktopVw(15)};
  }
`

const RewardOverviewText = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  font-family: ${props => props.theme.fonts.grosa};
  line-height: 19px;

  &:last-child {
    margin-bottom: 38px;
  }

  @media (min-width: ${props => props.theme.breakpoints.desktopSmall}px) {
    font-size: ${desktopVw(13)};
    line-height: ${desktopVw(19)};
    padding: ${desktopVw(5)} 0;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      margin-bottom: ${desktopVw(26)};
    }
  }
`

const Total = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
  font-family: ${props => props.theme.fonts.grosa};
  font-size: 11px;
  line-height: 19px;
  border-top: 1px solid ${props => props.theme.colors.greyLighter};

  @media (min-width: ${props => props.theme.breakpoints.desktopSmall}px) {
    font-size: ${desktopVw(13)};
    line-height: ${desktopVw(19)};
  }
`

const TotalText = styled.div`
  font-weight: 500;
  align-self: flex-start;

  @media (min-width: ${props => props.theme.breakpoints.desktopSmall}px) {
    margin-right: ${desktopVw(32)};
  }
`

const TotalPoints = styled.span`
  font-weight: 500;
`

const NoReferrals = styled.p`
  font-family: ${props => props.theme.fonts.grosa};
  color: ${props => props.theme.colors.darkGray3};
`

const ReferralPoints = ({ title, referrals, totalText, noReferralsMsg }) => {
  const [totalPoints, setTotalPoints] = useState(null)

  useEffect(() => {
    if (!referrals) return

    const total = referrals.reduce((acc, v) => acc + v.points, 0)

    setTotalPoints(total)
  }, [referrals])

  return (
    <StyledReferralPoints className="referral-points">
      <Collapsible title={title}>
        <Overview>
          {referrals?.map(({ email, points }, i) => (
            <RewardOverviewText key={`${email}${i}`}>
              <div>{email}</div>
              <div>{parseInt(points).toLocaleString()}</div>
            </RewardOverviewText>
          ))}
        </Overview>
        {referrals && referrals.length > 0 ? (
          <Total className="referral-points__total">
            <TotalText>{totalText}</TotalText>
            <TotalPoints>{totalPoints ? parseInt(totalPoints).toLocaleString() : 0}</TotalPoints>
          </Total>
        ) : (
          <NoReferrals>{noReferralsMsg}</NoReferrals>
        )}
      </Collapsible>
    </StyledReferralPoints>
  )
}

export default ReferralPoints
